import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/admin", { replace: true });
        return;
      }
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true, timeout: 45000 }
        );
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (e) {
        window.history.replaceState(null, "", "/admin");
        setFailed(true);
      }
    };
    run();
  }, [navigate]);

  if (failed) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-crema px-5">
        <div className="max-w-md w-full text-center" data-testid="auth-callback-error">
          <div className="w-14 h-14 rounded-full bg-fuchsiabrand flex items-center justify-center mx-auto mb-6">
            <AlertCircle className="text-white" size={24} />
          </div>
          <h1 className="font-display uppercase text-espresso text-3xl mb-4">
            Accesso non riuscito
          </h1>
          <p className="text-stone mb-8">
            Non sono riuscita a completare l'accesso. Controlla la connessione e riprova.
          </p>
          <a
            href="/admin"
            data-testid="auth-callback-retry"
            className="inline-block bg-espresso text-crema py-4 px-10 rounded-full font-mono text-xs uppercase tracking-[0.15em] hover:bg-fuchsiabrand transition-colors duration-300"
          >
            Riprova l'accesso
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-crema">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-stone">
        Accesso in corso…
      </p>
    </div>
  );
}
